// src/components/onboarding/OnboardingStepper.js
import React from 'react';
import { Link } from 'react-router-dom';

const OnboardingStepper = ({ steps, currentStep }) => {
  return (
    <div className="py-4">
      <div className="flex items-center justify-center">
        <div className="hidden md:flex items-center w-full max-w-4xl">
          {steps.map((step, index) => (
            <React.Fragment key={step.name}>
              {/* Step circle */}
              <div className="relative flex flex-col items-center">
                <div 
                  className={`flex items-center justify-center w-8 h-8 rounded-full border-2 font-medium ${
                    index < currentStep 
                      ? 'border-primary-500 bg-primary-500 text-white' 
                      : index === currentStep 
                        ? 'border-primary-500 bg-white text-primary-500' 
                        : 'border-gray-300 bg-white text-gray-500'
                  }`}
                >
                  {/* Check mark for completed steps */}
                  {index < currentStep ? (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
                <div className="mt-2 text-xs text-center font-medium text-gray-600">
                  {step.name}
                </div>
              </div>
              
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div 
                  className={`flex-1 h-0.5 mx-2 ${
                    index < currentStep ? 'bg-primary-500' : 'bg-gray-300'
                  }`}
                ></div>
              )}
            </React.Fragment>
          ))}
        </div>
        
        {/* Mobile view - just show current step name and number */}
        <div className="md:hidden text-center">
          <div className="flex items-center justify-center">
            <div 
              className="flex items-center justify-center w-8 h-8 rounded-full border-2 border-primary-500 bg-white text-primary-500 font-medium"
            >
              {currentStep + 1}
            </div>
            <span className="ml-2 text-sm font-medium text-gray-700">
              {steps[currentStep]?.name}
            </span>
            <span className="mx-2 text-gray-500">/</span>
            <span className="text-sm text-gray-500">{steps.length}</span>
          </div>
        </div>
      </div>
      
      {/* Success message - displays for steps that are complete */}
      {currentStep > 0 && (
        <div className="flex justify-center mt-4">
          <div className="bg-green-50 text-green-800 px-4 py-2 rounded-md text-sm flex items-center">
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>
              {steps[currentStep - 1]?.name} saved successfully.
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingStepper;